<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="p-content link-container">
      <div class="link-title">联系我们</div>
      <div class="link-firm">浪潮智能终端有限公司</div>
      <div class="link-item">客服电话：400-658-6111</div>
      <div class="link-item">客服邮箱：iitpm01@inspur.com</div>
      <div class="link-item">
        公司地址：山东省济南市高新区浪潮路1036号浪潮科技园
      </div>
      <div class="link-item">邮政编码：250101</div>
      <div class="link-item">有任何需求，欢迎随时联系我们，我们将竭诚为您服务！您可以通过发送电子邮件、拨打咨询电话等方式与我们取得沟通，我们将第一时间为您服务。</div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'LinkUs',
  components: {
    Search
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }
}
</script>

<style scoped>
.link-container {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 50px;
}
.link-title {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
}
.link-firm {
  font-size: 16px;
  color: black;
  font-weight: bold;
  margin-top: 30px;
}
.link-item {
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
}
</style>
